
  import Vue from 'vue';
  import PopularCategoryCard from '@/components/PopularCategoryCard';
export default {
  components: {
    PopularCategoryCard
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.title,
        },
        {
          hid: 'twitter:title',
          property: 'twitter:title',
          content: this.title,
        },

        {
  hid: 'description',
  name: 'description',
  content: 'Explore the best of North Goa with unforgettable sightseeing experiences. From stunning beaches to historical landmarks, discover everything this vibrant region has to offer.',
},
{
  hid: 'og:description',
  property: 'og:description',
  content: 'Discover the top sightseeing spots in North Goa. From beautiful beaches to historic sites, explore the vibrant culture and scenic landscapes of this amazing region.',
},
{
  hid: 'twitter:description',
  property: 'twitter:description',
  content: 'Enjoy the best of North Goa sightseeing. Visit stunning beaches, historic landmarks, and vibrant local spots for a truly unforgettable experience.',
},



        {
          hid: 'keywords',
          name: 'keywords',
          content: 'north goa sightseeing tour, north goa sightseeing package by car, north goa sightseeing package by bus, north goa sightseeing itinerary, north goa sightseeing package by ac bus, north goa sightseeing places, north goa sightseeing package by car price, north goa sightseeing tour, north goa sightseeing list, north goa sightseeing tour itinerary',
        },
     
      ],
    };
  },

  components: {},
  data() {
    return {

      reasons: [
    {
      title: "Stunning Destinations",
      text: "Discover breathtaking views and hidden gems with the best sightseeing spots in Goa!",
    },
    {
      title: "Fun for Everyone",
      text: "Whether you're an adventure lover or prefer a relaxed tour, there's something for everyone!",
    },
    {
      title: "Local Guides",
      text: "Our experienced guides will take you to the top attractions and share fascinating insights.",
    },
    {
      title: "Easy Booking",
      text: "Book your perfect sightseeing tour effortlessly through the Goa App at great rates!",
    },
  ],

      title: 'North Goa Sightseeing Tour - North Goa Sightseeing Tour Itinerary',
    };
  },

  jsonld() {
  return {
    '@context': 'https://schema.org',
    '@graph': [
    {
                "@type": "ImageObject",
                "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-02-28T07%3A22%3A03.678Zbaga-beach-1.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=MEZtAobjGQMmvVd70RanXh9mINNmpY5zZoYYf4Ksm38KNIJJ2dMxomE7WdGft5E25jTYLhNFCaYLyDSDQa4BZF%2Bonx07elRwYWCjGxWKEeqVFvn9Mj%2FiOq8CizoCsvPNjp4k3Y3e4Ks5vdWLCWgi5NowFQtFliDbUESLAYVuBPJN%2FUD3gjDm24fVMF7KOc77gtoRRHvospa48dPrLMlZ28mE51cvzhMu4dM%2FrUgpFCMNwIF2bx%2B%2FsuPuRBTI5oZskYN8SakceLx63BP8xMVyHAQVduhiFNcTLzCfUtonGAQdaBbUsieWZEITN2cpRfta3jUc6y1iGOOU65T0GOivaw%3D%3D',
                "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-02-28T07%3A22%3A03.678Zbaga-beach-1.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=MEZtAobjGQMmvVd70RanXh9mINNmpY5zZoYYf4Ksm38KNIJJ2dMxomE7WdGft5E25jTYLhNFCaYLyDSDQa4BZF%2Bonx07elRwYWCjGxWKEeqVFvn9Mj%2FiOq8CizoCsvPNjp4k3Y3e4Ks5vdWLCWgi5NowFQtFliDbUESLAYVuBPJN%2FUD3gjDm24fVMF7KOc77gtoRRHvospa48dPrLMlZ28mE51cvzhMu4dM%2FrUgpFCMNwIF2bx%2B%2FsuPuRBTI5oZskYN8SakceLx63BP8xMVyHAQVduhiFNcTLzCfUtonGAQdaBbUsieWZEITN2cpRfta3jUc6y1iGOOU65T0GOivaw%3D%3D',
                "contentUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-02-28T07%3A22%3A03.678Zbaga-beach-1.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=MEZtAobjGQMmvVd70RanXh9mINNmpY5zZoYYf4Ksm38KNIJJ2dMxomE7WdGft5E25jTYLhNFCaYLyDSDQa4BZF%2Bonx07elRwYWCjGxWKEeqVFvn9Mj%2FiOq8CizoCsvPNjp4k3Y3e4Ks5vdWLCWgi5NowFQtFliDbUESLAYVuBPJN%2FUD3gjDm24fVMF7KOc77gtoRRHvospa48dPrLMlZ28mE51cvzhMu4dM%2FrUgpFCMNwIF2bx%2B%2FsuPuRBTI5oZskYN8SakceLx63BP8xMVyHAQVduhiFNcTLzCfUtonGAQdaBbUsieWZEITN2cpRfta3jUc6y1iGOOU65T0GOivaw%3D%3D',
                "caption": 'Goa App',
                "inLanguage": "en-US",
                "width": 800,
                "height": 440
            }, 
            {
            "@type": "BlogPosting",
            "@id": `https://www.goa.app/north-goa-sightseeing-tour`,
                mainEntityOfPage: {
                    '@type': 'WebPage',
                    '@id': `https://www.goa.app/north-goa-sightseeing-tour`
                },
                "headline": 'Goa App',
                "name": 'Goa App',
                description: '',
                datePublished: '2024-10-26T20:14:36+00:00',
                dateModified: '2024-10-26T20:14:36+00:00',
                author: {
                    '@type': 'Person',
                    name: 'Goa App',
                    url: "https://goa.app"
                },
                publisher: {
                    '@type': 'Organization',
                    "@id": "https://goa.app",
                    name: 'Goa App',
                    logo: {
                        '@type': 'ImageObject',
                        url: 'https://goa.app/goa-app-logo.svg'
                    }
                },
                "image": {
                    "@type": "ImageObject",
                    "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-02-28T07%3A22%3A03.678Zbaga-beach-1.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=MEZtAobjGQMmvVd70RanXh9mINNmpY5zZoYYf4Ksm38KNIJJ2dMxomE7WdGft5E25jTYLhNFCaYLyDSDQa4BZF%2Bonx07elRwYWCjGxWKEeqVFvn9Mj%2FiOq8CizoCsvPNjp4k3Y3e4Ks5vdWLCWgi5NowFQtFliDbUESLAYVuBPJN%2FUD3gjDm24fVMF7KOc77gtoRRHvospa48dPrLMlZ28mE51cvzhMu4dM%2FrUgpFCMNwIF2bx%2B%2FsuPuRBTI5oZskYN8SakceLx63BP8xMVyHAQVduhiFNcTLzCfUtonGAQdaBbUsieWZEITN2cpRfta3jUc6y1iGOOU65T0GOivaw%3D%3D',
                    "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-02-28T07%3A22%3A03.678Zbaga-beach-1.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=MEZtAobjGQMmvVd70RanXh9mINNmpY5zZoYYf4Ksm38KNIJJ2dMxomE7WdGft5E25jTYLhNFCaYLyDSDQa4BZF%2Bonx07elRwYWCjGxWKEeqVFvn9Mj%2FiOq8CizoCsvPNjp4k3Y3e4Ks5vdWLCWgi5NowFQtFliDbUESLAYVuBPJN%2FUD3gjDm24fVMF7KOc77gtoRRHvospa48dPrLMlZ28mE51cvzhMu4dM%2FrUgpFCMNwIF2bx%2B%2FsuPuRBTI5oZskYN8SakceLx63BP8xMVyHAQVduhiFNcTLzCfUtonGAQdaBbUsieWZEITN2cpRfta3jUc6y1iGOOU65T0GOivaw%3D%3D',
                    "height": "440",
                    "width": "800"
                },
                "url": `https://www.goa.app/north-goa-sightseeing-tour`,
                "isPartOf": {
                    "@type": "Blog",
                    "@id": "https://www.goa.app/",
                    "name": "Goa App Blog",
                    "publisher": {
                        "@type": "Organization",
                        "@id": "https://goa.app",
                        "name": "Goa App"
                    }
                },
            },
            
            {
  "@type": "Product",
  "name": "North Goa Sightseeing Tour - Book @ ₹399 Flat 33% Off",
  "description": "Experience the best sightseeing in North Goa, where stunning landscapes, vibrant culture, and iconic landmarks come together for an unforgettable journey filled with picturesque moments.",
  "image": "https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-02-28T07%3A22%3A03.678Zbaga-beach-1.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=MEZtAobjGQMmvVd70RanXh9mINNmpY5zZoYYf4Ksm38KNIJJ2dMxomE7WdGft5E25jTYLhNFCaYLyDSDQa4BZF%2Bonx07elRwYWCjGxWKEeqVFvn9Mj%2FiOq8CizoCsvPNjp4k3Y3e4Ks5vdWLCWgi5NowFQtFliDbUESLAYVuBPJN%2FUD3gjDm24fVMF7KOc77gtoRRHvospa48dPrLMlZ28mE51cvzhMu4dM%2FrUgpFCMNwIF2bx%2B%2FsuPuRBTI5oZskYN8SakceLx63BP8xMVyHAQVduhiFNcTLzCfUtonGAQdaBbUsieWZEITN2cpRfta3jUc6y1iGOOU65T0GOivaw%3D%3D",
  "review": {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Goa App"
    }
  },
  "brand": {
    "@type": "Brand",
    "name": "Goa App"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "ratingCount": "89",
    "ratingValue": "5",
    "reviewCount": "44"
  },
  "offers": {
    "@type": "Offer",
    "price": "399",
    "priceValidUntil": "2025-12-31",
    "priceCurrency": "INR",
    "availability": "InStock",
    "seller": {
      "@type": "Organization",
      "name": "Goa App"
    }
  }
},

            {
        "@type": "WebPage",
        "@id": "https://www.goa.app/north-goa-sightseeing-tour",
        "url": "https://www.goa.app/north-goa-sightseeing-tour",
        "name": "North Goa Sightseeing Tour",
        "isPartOf": {
            "@id": "https://www.goa.app/#website"
        },
        "primaryImageOfPage": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-02-28T07%3A22%3A03.678Zbaga-beach-1.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=MEZtAobjGQMmvVd70RanXh9mINNmpY5zZoYYf4Ksm38KNIJJ2dMxomE7WdGft5E25jTYLhNFCaYLyDSDQa4BZF%2Bonx07elRwYWCjGxWKEeqVFvn9Mj%2FiOq8CizoCsvPNjp4k3Y3e4Ks5vdWLCWgi5NowFQtFliDbUESLAYVuBPJN%2FUD3gjDm24fVMF7KOc77gtoRRHvospa48dPrLMlZ28mE51cvzhMu4dM%2FrUgpFCMNwIF2bx%2B%2FsuPuRBTI5oZskYN8SakceLx63BP8xMVyHAQVduhiFNcTLzCfUtonGAQdaBbUsieWZEITN2cpRfta3jUc6y1iGOOU65T0GOivaw%3D%3D'
        },
        "image": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-02-28T07%3A22%3A03.678Zbaga-beach-1.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=MEZtAobjGQMmvVd70RanXh9mINNmpY5zZoYYf4Ksm38KNIJJ2dMxomE7WdGft5E25jTYLhNFCaYLyDSDQa4BZF%2Bonx07elRwYWCjGxWKEeqVFvn9Mj%2FiOq8CizoCsvPNjp4k3Y3e4Ks5vdWLCWgi5NowFQtFliDbUESLAYVuBPJN%2FUD3gjDm24fVMF7KOc77gtoRRHvospa48dPrLMlZ28mE51cvzhMu4dM%2FrUgpFCMNwIF2bx%2B%2FsuPuRBTI5oZskYN8SakceLx63BP8xMVyHAQVduhiFNcTLzCfUtonGAQdaBbUsieWZEITN2cpRfta3jUc6y1iGOOU65T0GOivaw%3D%3D'
        },
        "thumbnailUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-02-28T07%3A22%3A03.678Zbaga-beach-1.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=MEZtAobjGQMmvVd70RanXh9mINNmpY5zZoYYf4Ksm38KNIJJ2dMxomE7WdGft5E25jTYLhNFCaYLyDSDQa4BZF%2Bonx07elRwYWCjGxWKEeqVFvn9Mj%2FiOq8CizoCsvPNjp4k3Y3e4Ks5vdWLCWgi5NowFQtFliDbUESLAYVuBPJN%2FUD3gjDm24fVMF7KOc77gtoRRHvospa48dPrLMlZ28mE51cvzhMu4dM%2FrUgpFCMNwIF2bx%2B%2FsuPuRBTI5oZskYN8SakceLx63BP8xMVyHAQVduhiFNcTLzCfUtonGAQdaBbUsieWZEITN2cpRfta3jUc6y1iGOOU65T0GOivaw%3D%3D',
        "datePublished": "2024-10-26T20:14:36+00:00",
        "dateModified": "2024-10-26T20:14:36+00:00",
        "description": "North Goa sightseeing Tour offers breathtaking views of stunning beaches, vibrant culture, and scenic landscapes. It’s an ideal destination for travelers looking to explore beautiful sunsets, historic sites like Aguada Fort, and lush greenery, creating unforgettable memories along the way.",
        "breadcrumb": {
            "@id": "https://www.goa.app/north-goa-sightseeing-tour/#breadcrumb"
        },
        "inLanguage": "en-US",
        "potentialAction": [{
            "@type": "ReadAction",
            "target": ["https://www.goa.app/north-goa-sightseeing-tour"]
        }]
      },
      {
        "@type": "FAQPage",
  "mainEntity": [
  {
      "@type": "Question",
      "name": "What are the best sightseeing spots in North Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Some of the best sightseeing spots in North Goa include Calangute Beach, Baga Beach, Aguada Fort, and the serene Sinquerim Beach."
      }
    },
    {
      "@type": "Question",
      "name": "What types of tours are available for North Goa sightseeing?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "In North Goa, you can find various sightseeing tours, including full-day trips, bus tours, and private car hire options."
      }
    },
    {
      "@type": "Question",
      "name": "How much does a North Goa sightseeing tour cost?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "North Goa sightseeing tours typically start from ₹399 for bus tours and ₹2,499 for car rentals, depending on the package chosen."
      }
    },
    {
      "@type": "Question",
      "name": "Can I customize my North Goa sightseeing tour?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, many tour operators in North Goa offer customizable packages tailored to your preferences and interests."
      }
    },
    {
      "@type": "Question",
      "name": "What is the best time for sightseeing in North Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The best time for sightseeing in North Goa is during the cooler months from November to February, ensuring pleasant weather."
      }
    },
    {
      "@type": "Question",
      "name": "Are there any restrictions on visiting certain sightseeing spots?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, some sightseeing locations in North Goa may have entry restrictions or require permits, especially during peak seasons."
      }
    },
    {
      "@type": "Question",
      "name": "Do sightseeing packages include a guide?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Most sightseeing packages in North Goa include a guide who can provide insights about the locations and culture."
      }
    },
    {
      "@type": "Question",
      "name": "Can I choose my sightseeing locations?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutely! Many tour operators will collaborate with you to select locations that match your interests for the tour."
      }
    },
    {
      "@type": "Question",
      "name": "What should I wear for a sightseeing tour in North Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "It's recommended to wear comfortable clothing and footwear, as you may be exploring various outdoor locations throughout the day."
      }
    },
    {
      "@type": "Question",
      "name": "How do I book a North Goa sightseeing tour?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "You can book a North Goa sightseeing tour through various travel agencies or online platforms specializing in Goan tours and activities."
      }
    }
        ]
      }
    ]
  };
},


};



  